module.exports = __webpack_public_path__ + "static/media/2_r_bashny_71.61_85.46.a3342436.png";